var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.peek,{tag:"component",attrs:{"event":_vm.event}})}
var staticRenderFns = []

export { render, staticRenderFns }